module.exports = __webpack_public_path__ + "static/media/skybox_internal_facility_m.b94f7d18.jpg";